import { useMemo } from 'react';
import { useRedirect, useSplatPathBase } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { useLocation, useParams } from 'react-router-dom';
import { FormPaths } from './FormWizard';

const useFormWizardNav = (formPaths: FormPaths[]) => {
  const { setValue } = useFormContext();
  const redirect = useRedirect();
  const { '*': path } = useParams();
  const splatPathBase = useSplatPathBase();
  const { state } = useLocation();

  const filteredPaths = useMemo(() => formPaths.filter(
    (formPath) => formPath?.hidden !== true,
  ), [formPaths]);

  const childrenPaths = filteredPaths.map((formPath) => formPath.path);

  const currentPosition = useMemo(() => childrenPaths
    .findIndex((child) => child === path), [childrenPaths, path]);

  const next = () => {
    const nextPath = childrenPaths.at(currentPosition + 1) ?? path!;
    redirect(`${splatPathBase}/${nextPath}`, undefined, undefined, undefined, state);
    setValue('_reValidate', true, { shouldValidate: true });
  };

  const previous = () => {
    const previousPath = childrenPaths.at(currentPosition - 1) ?? path;
    redirect(`${splatPathBase}/${previousPath}`, undefined, undefined, undefined, state);
    setValue('_reValidate', true, { shouldValidate: true });
  };

  return {
    currentPath: formPaths[currentPosition],
    next,
    previous,
    isFirstPage: childrenPaths[0] === path,
    isLastPage: childrenPaths.slice(-1)[0] === path,
  };
};

export default useFormWizardNav;
